import { render, staticRenderFns } from "./StageEdit.vue?vue&type=template&id=20f09929&"
import script from "./StageEdit.vue?vue&type=script&lang=js&"
export * from "./StageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports